import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export default function ReadOnlyPlugin() {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        editor.setEditable(false);
    }, [editor]);

    return null;
}
